var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        "background-color": "#f1f6ff !important",
        "min-height": "100vh",
      },
      attrs: { id: "inside" },
    },
    [
      _vm.fullName !== null
        ? _c(
            "div",
            {
              staticClass: "container mb-3",
              staticStyle: {
                "margin-top": "60px",
                "max-width": "1140px !important",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    class: [
                      _vm.largura < 500
                        ? "col-12 col-lg-12 p-3"
                        : "col-12 col-lg-12 p-0",
                    ],
                  },
                  [
                    _c("h5", { staticClass: "text-body mb-1" }, [
                      _vm._v("Olá, " + _vm._s(_vm.fullName)),
                    ]),
                    _c("p", { staticClass: "text-info mb-2" }, [
                      _vm._v(
                        " CPF " +
                          _vm._s(
                            _vm
                              .formatDocument(_vm.accessdocFormated)
                              .split(".")[0]
                              .substring(0, 6) +
                              ".XXX" +
                              "." +
                              "XXX-" +
                              _vm
                                .formatDocument(_vm.accessdocFormated)
                                .split("-")[1]
                          ) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "text-info mb-3" }, [
                      _vm._v(" Confira as opções de negociação disponíveis: "),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "nav",
        {
          staticClass: "navbar navbar-expand fixed-top",
          staticStyle: { "max-height": "63px !important" },
        },
        [
          _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "max-width": "1140px !important" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "navbar-brand text-primary",
                  attrs: { href: "/" },
                },
                [
                  _c("img", {
                    staticClass: "d-block",
                    attrs: { src: "/img/LogoPortoBank1.svg", height: "23 vh" },
                    on: {
                      click: function ($event) {
                        return _vm.clickLogo()
                      },
                    },
                  }),
                ]
              ),
              _c("p", { staticClass: "title-space mb-2 mt-2" }, [
                _vm._v("Negocie Porto Bank"),
              ]),
              _c("ul", { staticClass: "navbar-nav ml-auto text-secondary" }, [
                _c("a", {
                  staticClass:
                    "sidebar-brand d-flex align-items-right justify-content-right",
                  attrs: { href: "index.html" },
                }),
                _vm._m(0),
                _vm.fullName !== null
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "nav-item dropdown no-arrow text-secondary",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link dropdown-toggle",
                            attrs: {
                              href: "#",
                              id: "userDropdown",
                              role: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false",
                            },
                          },
                          [
                            _c("span", { staticClass: "mr-2 small" }, [
                              _vm._v(_vm._s(_vm.fullName.split(" ")[0])),
                            ]),
                            _c("i", { staticClass: "fa fa-bars fa-fw fa-lg" }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu dropdown-menu-right shadow animated--grow-in",
                            attrs: { "aria-labelledby": "userDropdown" },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.alterarCadastro()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-user-o fa-sm fa-fw mr-2",
                                }),
                                _vm._v(" Cadastro "),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.alterarSenha()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-key fa-sm fa-fw mr-2",
                                }),
                                _vm._v(" Alterar código "),
                              ]
                            ),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._m(1),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _c("ProgressLoading", {
                style: _vm.fullName === null ? "margin-top: 50px;" : "",
                attrs: { loading: _vm.loading },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item dropdown no-arrow" }, [
      _c("a", {
        staticClass:
          "sidebar-brand d-flex align-items-right justify-content-right",
        attrs: { href: "index.html" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "dropdown-item",
        attrs: { href: "#", "data-toggle": "modal", "data-target": "#logout" },
      },
      [
        _c("i", {
          staticClass: "fa fa-sign-out fa-sm fa-fw mr-2 text-gray-400",
        }),
        _vm._v(" Logout "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }